import React from 'react';
import PropTypes from 'prop-types';
import { year, month } from './../static-data/glossary';

const ScheduleTableTitle = props => (
    <div className="schedule-title">
        <div className="schedule-title__title-text">{month.im} {year}</div>
        <ul className="schedule-title__list">
            {props.days.map(day => (
                <li className="schedule-title__day schedule-title__day_border_no" data-day={day.date} key={day.id}>
                    {day.date}
                    <span className="schedule-title__weekday schedule-title__weekday_color_gray">
                        {day.weekDay.short}
                    </span>
                </li>
            ))}
        </ul>
    </div>
);

ScheduleTableTitle.propTypes = {
    days: PropTypes.arrayOf(PropTypes.shape({
        weekDay: PropTypes.shape({
            short: PropTypes.string
        }),
        date: PropTypes.number,
        id: PropTypes.number
    })).isRequired
};

export default ScheduleTableTitle;



// WEBPACK FOOTER //
// ./src/components/ScheduleTableTitle.jsx